<template>
<div class="section">
  <div class="container">
    <h1 class="title is-1 has-text-centered">Lobby</h1>
    <div v-if="game && game.data.status === 'pregame' || showCountdown">
      <div v-if="showCountdown" class="countdown">
        {{count}}
        <div class="trivia-instructions">
          <b-message :closable="false">
            Get Ready! You will get 10s per question.
          </b-message>
        </div>
      </div>
      <div v-if="amOwner && !showCountdown" class="">
        <div  class="columns is-mobile is-centered is-vcentered">
          <div class="column link-column">
            <div ref="linkContainer" @click="copy" class="info-box dont-break-out">
              https://munchybit.com/join/{{gameId}}
            </div>
          </div>
        </div>
        <div class="game-instructions">
          <div class="columns is-mobile is-vcentered">
            <div class="column is-narrow">
              <span class="tag is-rounded is-medium">1</span>
            </div>
            <div class="column">
              Share the link above to invite friends
            </div>
          </div>
          <div class="columns is-mobile is-vcentered">
            <div class="column is-narrow">
              <span class="tag is-rounded is-medium">2</span>
            </div>
            <div class="column">
              Wait for all players to join
            </div>
          </div>
          <div class="columns is-mobile is-vcentered">
            <div class="column is-narrow">
              <span class="tag is-rounded is-medium">3</span>
            </div>
            <div class="column">
              Press the button below to start the fun!
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered section" v-else>
        <h2 v-if="game && !showCountdown" class="title is-3">Waiting for {{game.data.name}} to start the game...</h2>
      </div>
      <hr />
      <players />
      <div v-if="amOwner && !showCountdown" class="start-button has-text-centered">
        <button @click="startGame" class="button is-primary is-large">
          <span>Start Trivia</span>
          <span class="icon">
            <i class="fas fa-arrow-circle-right"></i>
          </span>
        </button>
      </div>
    </div>
    <div v-else-if="game && !showCountdown" class="error-message">
      <b-notification
        type="is-danger"
        has-icon
        icon-pack="fas"
        icon="alert"
        role="alert"
        :closable="false">
        This game is already in progress or has been completed.
      </b-notification>
    </div>
  </div>
</div>
</template>

<script>
import Players from './ub-players.vue';

export default {
  name: 'ub-lobby',
  props: [],
  watch: {
    game: {
      handler(value, oldValue) {
        if (value.data.status === 'in-progress'
          && oldValue.data.status !== 'in-progress') {
          this.showCountdown = true;
          this.$timer.start('countdown');
        }
      },
    }
  },
  timers: {
    countdown: {
      time: 1000,
      repeat: true,
    },
  },
  data() {
    return {
      showCountdown: false,
      count: 5,
      isBusy: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/dbUser'];
    },
    gameId() {
      return this.$route.params.gameId;
    },
    game() {
      return this.$store.getters['trivia/trivia'];
    },
    amOwner() {
      return this.user.id === this.game.data.createdById;
    },
  },
  methods: {
    countdown() {
      this.count -= 1;
      if (this.count === 0) {
        this.$timer.stop('countdown');
        console.log('this is where we go to question');
        this.$router.push({
          name: 'ub-question',
        });
      }
    },
    copy() {
      const range = document.createRange();
      range.selectNode(this.$refs.linkContainer);
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand('copy');
      this.$buefy.toast.open({
        type: 'is-info',
        message: 'Link copied!',
      });
    },
    startGame() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.$store.dispatch('trivia/modify', {
        gameId: this.gameId,
        payload: {
          status: 'in-progress',
        },
      }).then(() => {
        this.isBusy = false;
      }).catch((err) => {
        this.isBusy = false;
        console.error(err);
        throw err;
      });
    },
  },
  mounted() {
    if (!this.game) {
      this.$router.push({
        name: 'ub-home',
      });
    }
  },
  components: {
    Players,
  },
};
</script>

<style lang="scss" scoped>

.countdown{
  font-size: 5rem;
  text-align: center;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.trivia-instructions{
  max-width: 400px;
}

.link-column{
  max-width: 450px;
}

.game-instructions{
  text-align: center;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  .columns{
    text-align: left;
    margin-bottom: 0rem;
    &.is-gapless{
      margin-bottom: 0rem;
    }
  }
}

.error-message{
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

</style>
